import * as React from "react"
let styles = require("./styles.module.scss")
import cx from "classnames"

export type TeslaToggleAssumptionsProps = {
  updateFn?: () => void
}

export default class TeslaToggleAssumptions extends React.Component<
  TeslaToggleAssumptionsProps
> {
  constructor(props) {
    super(props)
  }

  render() {
    const { updateFn } = this.props

    return (
      <a className={styles.toggle} onClick={() => updateFn()}>
        <i className={styles.icon}>
          <span />
          <span />
        </i>
        <span
          className={cx({
            [styles.see]: true,
            ["bet-LinkUnderline"]: true,
          })}
        >
          Show assumptions
        </span>
        <span
          className={cx({
            [styles.hide]: true,
            ["bet-LinkUnderline"]: true,
          })}
        >
          Hide assumptions
        </span>
      </a>
    )
  }
}
